import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/certificates', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/certificates', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
        .put(`/api/certificates/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update }